import { ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE } from "constants/chatType";
import { useGetActionItemsQuery } from "store/apis/actionItems";
import { BooksActionItems } from "types/Models/books";

type UseBookActionItemsArgs = {
  groupId: string;
  card_status?: "REQUESTED" | "DEPRECATED" | "SUBMITTED";
};

export const useBookActionItems = ({
  groupId,
  card_status,
}: UseBookActionItemsArgs) => {
  const {
    data: groupBooksActionItems,
    isLoading: isGroupBooksLoading,
    isSuccess: isGroupBooksSuccess,
  } = useGetActionItemsQuery(
    {
      groupId: groupId,
      type: "BOOKS",
      card_status,
    },
    { skip: !groupId, refetchOnMountOrArgChange: true }
  );

  const { action_items_response, channel_url } =
    (groupBooksActionItems as BooksActionItems) || {};

  const allBooksActionItems =
    (action_items_response as any[])?.flatMap(
      ({ items, item_type, items_count }) => {
        if (item_type === ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE) {
          return [{ ...items[0], item_type, items_count }];
        }
        return items.map((item: any) => ({ ...item, item_type, items_count }));
      }
    ) || [];

  const totalActionItemCount = allBooksActionItems.length;
  const isEmpty = totalActionItemCount === 0;

  return {
    allItems: allBooksActionItems,
    totalActionItemCount,
    isEmpty,
    isLoading: isGroupBooksLoading,
    isSuccess: isGroupBooksSuccess,
  };
};
